import { render, staticRenderFns } from "./TabPanePro.vue?vue&type=template&id=e43ea2be&scoped=true"
import script from "./TabPanePro.vue?vue&type=script&lang=js"
export * from "./TabPanePro.vue?vue&type=script&lang=js"
import style0 from "./TabPanePro.vue?vue&type=style&index=0&id=e43ea2be&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e43ea2be",
  null
  
)

export default component.exports